import { render } from "./TheHeaderNaviOfOtherMenu.vue?vue&type=template&id=0bf2f8f2&ts=true"
import script from "./TheHeaderNaviOfOtherMenu.vue?vue&type=script&lang=ts"
export * from "./TheHeaderNaviOfOtherMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__